<template>
  <Modal @close="$emit('close-modal')">
    <BoxForm
      :messageError="messageError"
      @clena-error="messageError = !messageError"
      :loading="loading"
    >
      <template v-slot:header>
        <span>{{ mode === "new-user" ? "Cadastrar " : "Editar " }} {{is_pt_br ? 'Usuário' : 'User'}}</span>
      </template>

      <template>
        <div class="row">
          <div class="form-group p-1 col-12 d-flex flex-column">
            <input
              v-model="user.username"
              type="text"
              class="form-control"
              placeholder="Username"
            />
            <small class="text-muted">Username</small>
          </div>
          <div class="form-group p-1 col-12 d-flex flex-column">
            <input
              v-model="user.email"
              v-debounce:800ms="validateEmail"
              type="text"
              class="form-control"
              placeholder="Email"
            />
            <small class="text-muted">Email</small>
          </div>
          <div v-show="mode === 'new-user'" class="form-group p-1 col-6">
            <input
              v-model="user.password"
              type="password"
              class="form-control"
              :placeholder="is_pt_br ? 'Senha' : 'Password'"
            />
            <small class="text-muted">{{is_pt_br ? 'Senha' : 'Password'}}</small>
          </div>
          <div v-show="mode === 'new-user'" class="form-group p-1 col-6">
            <input
              v-model="user.password_confirm"
              type="password"
              class="form-control"
              :placeholder="is_pt_br ? 'Confirmar senha' : 'Confirm password'"
            />
            <small class="text-muted">{{is_pt_br ? 'Confirmar senha' : 'Confirm password'}}</small>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="row mt-3 p-0">
          <div class="col-12 d-flex p-0 justify-content-end">
            <button
              class="btn btn-outline-dark"
              @click.prevent="handleSubmitForm()"
            >
              {{ mode === "new-user" ? "Add" : "Edite" }}
            </button>
          </div>
        </div>
      </template>
    </BoxForm>
  </Modal>
</template>

<script>
import Modal from "../utils/Modal.vue";
import BoxForm from "../utils/BoxForm.vue";
import { mapActions } from "vuex";
export default {
  name: "FormUser",
  components: { Modal, BoxForm },
  props: {
    user: Object,
    mode: String,
  },
  data() {
    return {
      messageError: "",
      loading: false,
    };
  },
  computed: {
    is_pt_br(){
      return this.$store.getters.is_pt_br
    }
  },
  methods: {
    ...mapActions("user", ["editeUser", "createUser"]),
    ...mapActions('alertes', ['alertSuccess']),

    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    handleSubmitForm() {
      if (!this.validateEmail(this.user.email)) {
        this.messageError = "Email invalido";
      }
      if (this.mode == "new-user") {
        if (this.user.password !== this.user.password_confirm) {
          this.messageError = "Senhas não são iguais!";
          return false;
        } else {
          this.handleNewUser();
        }
      } else this.handleEditeUser();
    },
    async handleNewUser() {
      this.loading = true;
      await this.createUser(this.user)
        .then((res) => {
          console.log("Usuário criado com sucesso");
          this.alertSuccess('Usuário cadastrado com sucesso!')
          this.$emit("close-modal");
        })
        .catch((error) => {
          console.error("erro na edição de blocos =>>", error);
          this.$emit("close-modal", error);
        });
      this.loading = false;
    },

    async handleEditeUser() {
      this.loading = true;
      await this.editeUser(this.user)
        .then((res) => {
          this.alertSuccess('Usuário editado com sucesso!')
          this.$emit("close-modal", null);
        })
        .catch((error) => {
         this.messageError = `Algo deu errado: ${error.data} `
        });
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  height: 18px;
  width: 18px;
}
</style>
